<template>
  <div
    class="details-pagearea primary-page"
    v-wechat-title="($route.meta.title = seriesData.name)"
  >
    <div class="mask-contain">
      <img class="cover" :src="seriesData.teacher_image" alt="" />
      <div class="msg-box">
        <div class="name">{{ seriesData.name }}</div>
        <div class="summary">{{ seriesData.summary }}</div>
      </div>
      <div class="more-msg-box">
        <div class="nums-box">
          <div class="price-box">
            <div class="price">{{ seriesData.price }}</div>
            <div v-if="seriesData.original_price" class="original-price">
              {{ seriesData.original_price }}
            </div>
          </div>
          <div class="sale-count" v-if="seriesData.show_camp_sale_count">
            总报名{{ seriesData.camp_sale_count }}人
          </div>
        </div>
        <div class="cover-zone">
          <img class="cover-img" :src="seriesData.teacher_image" alt="" />
        </div>
        <div class="cnum-nd-cdate-box">
          <div class="current-camp">
            <span class="camp-num">第{{ seriesData.camp_num + 1 }}期</span>
            <span class="training-date" v-if="seriesData.camp_label_id != 14"
              >开营时间：{{ seriesData.training_date }}</span
            >
          </div>
          <div
            v-if="seriesData.camp_info && seriesData.camp_info.length > 1"
            @click.stop="handlerChangeStage"
            class="choose-another-camp"
          >
            选期
          </div>
        </div>
      </div>
    </div>
    <!-- 广告区 -->
    <div class="advertising-wrapper" v-if="advData.is_show" v-cloak>
      <a class="link" :href="advData.jump_url">
        <img class="img" :src="advData.img_url" alt="" />
      </a>
    </div>

    <div class="divider"></div>
    <section class="about-camp-container">
      <ul class="tab-wrap">
        <div
          class="item"
          :class="{ current: currentMod === MOD_INTRO }"
          @click.stop="changeMod(MOD_INTRO)"
        >
          课程介绍
        </div>
        <div
          class="item"
          :class="{ current: currentMod === MOD_DIRECTORY }"
          @click.stop="changeMod(MOD_DIRECTORY)"
        >
          学习计划
        </div>
        <div
          class="item"
          v-if="seriesData.has_deeds"
          :class="{ current: currentMod === MOD_DEEDS }"
          @click.stop="changeMod(MOD_DEEDS)"
        >
          学员事迹
        </div>
      </ul>

      <!-- 课程介绍 -->
      <section
        class="wrapper intro-wrap"
        v-show="currentMod === MOD_INTRO"
        v-cloak
      >
        <div class="video-box" v-if="seriesData.video_url">
          <camp-promote-player
            :video-url="seriesData.video_url"
            :pause-it="pauseTheVideo"
          >
          </camp-promote-player>
        </div>
        <camp-intro
          v-if="articleContent"
          :article-content="articleContent"
        ></camp-intro>
      </section>
      <!-- 学习计划 -->
      <section
        class="wrapper learn-plan-wrap"
        v-show="currentMod === MOD_DIRECTORY"
        v-cloak
      >
        <!-- 试看 -->
        <div
          class="try-see-container"
          v-if="seriesData.learn_plan && seriesData.learn_plan.try_see.length"
          v-cloak
        >
          <div class="main">
            <trysee-catalog-list
              :list="seriesData.learn_plan.try_see"
              :lesson-state="seriesData.state"
              :background-color="'#f6f7fa'"
              :series-id="+seriesId"
            ></trysee-catalog-list>
          </div>
        </div>
        <div
          v-if="seriesData.learn_plan && seriesData.learn_plan.modules.length"
          class="modules-wrapper"
          style="padding: 0 16px 40px"
        >
          <div
            v-for="(item, index) in seriesData.learn_plan.modules"
            class="box"
            :class="{ 'if-preview': item.type === 0 }"
            :key="index"
          >
            <camp-detail-plan-module
              :module-mode="Boolean(seriesData.learn_plan.module_mode)"
              :training-date="seriesData.training_date"
              :data="item"
              :series-id="+seriesId"
              :is-paid="seriesData.is_paid"
            ></camp-detail-plan-module>
          </div>
        </div>
      </section>
      <!-- 学员事迹 -->
      <section class="wrapper" v-show="currentMod === MOD_DEEDS" v-cloak>
        <template v-for="(item, index) in deedsList">
          <deed-item
            v-if="deedsList.length"
            :key="index"
            :data="item"
          ></deed-item>
        </template>
      </section>
    </section>

    <!-- 底部操作栏 -->
    <div class="page-bottom-fixed-wrapper">
      <div class="service">
        <i class="tip-text" v-if="unReadInfoNum">{{unReadInfoNum}}</i>
        <img
          src="@/assets/service-icon.png"
          alt="service"
          class="service-icon"
          @click="handlerServiceBtn"
        />
      </div>

      <!-- 这里还可以放咨询按钮 -->
      <div class="operate-bar-box">
        <a :href="indexUrl" class="s-btn home-btn">
          <i class="icon"></i>
          <span class="text">首页</span>
        </a>
        <div
          class="s-btn favor-btn"
          :class="{ 'is-favor': seriesData.is_favor }"
        >
          <i class="icon"></i>
          <span class="text" @click.stop="handleFavor()">{{
            seriesData.is_favor ? "已收藏" : "收藏"
          }}</span>
        </div>
        <div class="btns">
          <div
            v-if="seriesData.is_paid"
            @click.stop="jumpLearnPage"
            class="btn paid-btn"
          >
            开始学习
          </div>
          <div v-else-if="seriesData.state === 4" class="btn sale-out-btn">
            课程已下架
          </div>
          <div v-else class="btn buy-btn" @click.stop="handlerBuyBtn">
            立即购买
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：选择期数 -->
    <van-action-sheet
      v-model="showMoreCamps"
      safe-area-inset-bottom
      :close-on-click-overlay="false"
    >
      <div class="choose-camp-dialog-main">
        <i
          class="close-dialog"
          @click.stop="
            showMoreCamps = false;
            campDialogMark = null;
          "
        ></i>
        <div class="camp-msg-box">
          <div class="cover-zone">
            <img class="cover-img" :src="seriesData.teacher_image" alt="" />
          </div>
          <div class="cont-zone">
            <div class="name">{{ seriesData.name }}</div>
            <div class="price-box">
              <div class="price">{{ seriesData.price }}</div>
              <div class="original-price" v-if="seriesData.original_price">
                {{ seriesData.original_price }}
              </div>
            </div>
            <div class="selected-camp">
              第{{ seriesData.camp_num + 1 }}期 开营时间：{{
                seriesData.training_date
              }}
            </div>
          </div>
        </div>
        <div class="camps-box" v-if="!noChoiceList">
          <div class="subs">期数</div>
          <ul class="camp-list">
            <template v-for="(item, index) in seriesData.camp_info">
              <li
                class="camp-item"
                :class="{ current: item.id === seriesId }"
                :key="index"
                @click.stop="jumpPage(item)"
              >
                <span class="camp-num">第{{ item.camp_num + 1 }}期</span>
                <span class="training-date"
                  >开营时间：{{ item.training_date }}</span
                >
              </li>
            </template>
          </ul>
        </div>
        <div class="buy-btn">
          <span v-if="seriesData.state === 4" class="text sale-out"
            >课程已下架</span
          >
          <span v-else class="text buy" @click.stop="jumpOrderPage">
            {{ campDialogMark === FROM_CAMPS_BTN ? "立即购买" : "确定" }}
          </span>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet, Toast } from 'vant';
import request from '@/plugins/axios';
import Cookies from 'js-cookie';
import { FAVOR_TYPE, ADV_TYPE } from '@/common/js/config';
import startQiYuService from '@/config/qiyu';
import { initWxConfig } from '@/config/wxConfig';
import WxShare from '@/common/js/wxShare';
import deedItem from '@/components/deedItem/deedItem.vue';
import TryseeCatalogList from '@/components/TryseeCatalogList/TryseeCatalogList.vue';
import campIntro from '@/components/campIntro/campIntro.vue';
import campDetailPlanModule from '@/components/campDetailPlanModule/campDetailPlanModule.vue';
import campPromotePlayer from '@/components/campPromotePlayer/campPromotePlayer.vue';

import {
  // eslint-disable-next-line camelcase
  getLessonSeriesDetail_v4_0,
  // eslint-disable-next-line camelcase
  getCampSeriesLearnDetail_v4_0,
  getUserViewData,
  getCampDeeds,
  getAdv,
  requestUserFavorobj,
  requestUserUnfavorobj,
  getUserInfo
} from '@/api/api';
import { isWechat } from '@/common/js/utils';

const MOD_INTRO = 'camp_intro';
const MOD_DIRECTORY = 'camp_directory';
const MOD_DEEDS = 'camp_deeds';

// 记录选期弹窗发起来源
const FROM_BUY_BTN = 'from_buy_btn';
const FROM_CAMPS_BTN = 'from_camps_choice_btn';

export default {
  components: {
    deedItem,
    TryseeCatalogList,
    campIntro,
    campDetailPlanModule,
    campPromotePlayer,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      indexUrl: `${window.document.location.origin}?_source=wx_series_detail`,
      seriesData: {},
      userViewData: {},
      MOD_INTRO,
      MOD_DIRECTORY,
      MOD_DEEDS,
      currentMod: MOD_INTRO,
      showMoreCamps: false,
      advData: {},
      seriesId: null,
      campId: 0,
      deedsList: [],
      appId: 2,

      FROM_BUY_BTN,
      FROM_CAMPS_BTN,
      campDialogMark: null,

      articleContent: '',

      placeholderCoverShow: true,
      playerPauseHide: false,
      pauseTheVideo: false,

      salelinkId: null,
      noChoiceList: !!this.$route.query.noChoiceList,
    };
  },
  computed: {
    options() {
      return {
        scrollbar: true,
        useTransition: false,
      };
    },
    getVideoCoverStyle() {
      return 'width: 100%; height:192px;';
    },
    player() {
      return this.$refs.player;
    },
    isInitQiYu() {
      return this.$store.state.qiYu.isStart;
    },
    unReadInfoNum() {
      return this.$store.state.qiYu.unreadNum;
    }
  },
  watch: {
    currentMod(newValue) {
      if (newValue !== MOD_INTRO) {
        this.pauseTheVideo = true;
      } else {
        this.pauseTheVideo = false;
      }
    },
    $route(to) {
      if (this.seriesData.video_url) {
        this.seriesData.video_url = '';
      }
      if (this.articleContent) {
        this.articleContent = '';
      }
      if (this.deedsList.length) {
        this.deedsList = [];
      }

      const seriesIdStr = to.params.series_id;
      const seriesIdArr = seriesIdStr.split('-');
      this.seriesId = +seriesIdArr[0];
      this.salelinkId = seriesIdArr[1] || null;

      this.querySeriesDetail();
    }
  },
  created() {
    // eslint-disable-next-line no-underscore-dangle
    this.appId = this.$route.query._app_id || this.appId;
    const userId = Cookies.get('user_id');

    if (!userId) {
      setTimeout(async () => {
        // 不是在微信里打开且没有登录
        if (!isWechat()) {
          this.$router.replace({
            path: '/login',
            query: { redirect: `/camp/${this.$route.params.series_id}` },
          });
          return;
        }

        // 等待自动登录的结果
        const isSuccess = await this.verifyWxLogin();

        if (isSuccess) {
          this.$store.dispatch('getUserData');
        }

        if (!this.isInitQiYu) {
          getUserInfo().then((data) => {
            startQiYuService(data.id, data.nickname);
          }).catch(() => {
            startQiYuService(userId || 0);
          });
        }
      }, 0);
    } else if (!this.isInitQiYu) {
      // 登录了，但没有初始化七鱼sdk
      getUserInfo().then((data) => {
        startQiYuService(data.id, data.nickname);
      }).catch(() => {
        startQiYuService(userId || 0);
      });
    }


    const seriesIdStr = this.$route.params.series_id;
    const seriesIdArr = seriesIdStr.split('-');
    this.seriesId = +seriesIdArr[0];
    this.salelinkId = seriesIdArr[1] || null;
    this.querySeriesDetail();
    this.queryPageAdv();
    this.queryUserViewData();
  },
  methods: {
    querySeriesDetail() {
      // eslint-disable-next-line camelcase
      const sale_link_id = this.salelinkId || 0;

      getLessonSeriesDetail_v4_0(this.seriesId, sale_link_id).then(async (res) => {
        // console.log('res', res);
        document.title = res.name;
        this.seriesData = res;

        let hasLogin = !!Cookies.get('user_id');
        if (!hasLogin) {
          hasLogin = await this.verifyWxLogin();
        }
        if (hasLogin) {
          this.getLearn(this.seriesId);
        }
        this.queryCampDeeds(this.seriesData.camp_id);

        // 设置微信分享内容
        this.wxConfig().then(() => {
          this.setWxShare({
            title: res.name,
            desc: res.summary,
            link: window.location.href,
            imgUrl: res.teacher_image,
          });
        });

        // 课程介绍
        let introUrl = process.env.NODE_ENV !== 'development'
          ? this.seriesData.intro
          : this.seriesData.intro.replace('http://talcdn.jhkong.com', '');

        if (window.location.protocol === 'https:') {
          introUrl = introUrl.replace('http:', 'https:');
        }

        request({
          method: 'get',
          url: introUrl,
          withCredentials: false,
        }).then((articleContent) => {
          this.articleContent = articleContent;
        });
      });
    },
    /**
     * @description 验证微信自动登录是否已登录，失败跳转到登录页
     */
    async verifyWxLogin() {
      let checkCount = 20;

      /**
       * @description 每一百毫秒检测一次微信自动登录是否已登录成功，最多二十次
       * @returns {promise} 成功resolve(true)，失败resolve(false)
       */
      const isAutoLoginSuccess = () => new Promise((resolve) => {
        setTimeout(() => {
          const userId = Cookies.get('user_id');

          if (userId) {
            resolve(true);
          } else if (checkCount) {
            checkCount -= 1;
            isAutoLoginSuccess();
          } else {
            resolve(false);
          }
        }, 100);
      });

      const next = await isAutoLoginSuccess();

      // 自动登录失败
      if (!next) {
        return false;
      }

      return true;
    },
    queryUserViewData() {
      getUserViewData(this.seriesId, this.salelinkId).then((res) => {
        // console.log('viewdata-resdata', res.data);
        this.userViewData = res.data;
      });
    },
    queryCampDeeds(campId) {
      getCampDeeds(campId).then((res) => {
        // console.log('学员事迹', res);
        this.deedsList = res.items;
      });
    },
    changeMod(newMod) {
      this.pauseTheVideo = false;

      // props 响应性不够，所以采用延时器
      setTimeout(() => {
        this.pauseTheVideo = true;
      }, 10);

      if (newMod === this.currentMod) {
        return;
      }
      this.currentMod = newMod;
    },
    // 页面广告
    queryPageAdv() {
      getAdv(ADV_TYPE.camp_lesson_detail).then((res) => {
        this.advData = res;
      });
    },
    // 收藏/取消收藏
    handleFavor() {
      if (this.seriesData.is_favor) {
        requestUserUnfavorobj(this.seriesId, FAVOR_TYPE.camp_lesson).then(
          () => {
            this.seriesData.is_favor = false;
            // this.queryUserViewData()
          }
        );
      } else {
        requestUserFavorobj(this.seriesId, FAVOR_TYPE.camp_lesson).then(() => {
          this.seriesData.is_favor = true;
          // this.queryUserViewData()
        });
      }
    },
    jumpPage(data) {
      const queryData = {
        t: +new Date(),
      };

      if (this.$route.query.wkpay) {
        queryData.wkpay = this.$route.query.wkpay;
      }

      this.$router.push({
        path: `/camp/${data.id}`,
        query: queryData,
      });
      this.seriesId = data.id;
      this.querySeriesDetail();
      // this.queryUserViewData()
      this.queryPageAdv();
    },
    jumpOrderPage() {
      if (this.seriesData.is_paid) {
        Toast('已经报名了哦~');
        return;
      }

      const queryData = {
        _app_id: this.seriesData.app_id || 2
      };

      if (this.salelinkId) {
        queryData.sale_link_id = this.sale_link_id;
      }

      if (this.$route.query.wkpay) {
        queryData.wkpay = this.$route.query.wkpay;
      }

      this.$router.push({
        path: `/camp-order/${this.seriesData.id}`,
        query: queryData,
      });
    },
    jumpLearnPage() {
      this.$router.push({
        name: 'camp-learning',
        params: {
          series_id: this.seriesData.id,
        },
        meta: {
          title: this.seriesData.name,
        },
      });
    },

    wxConfig() {
      return initWxConfig(this.appId);
    },
    /**
     * @description 设置微信分享内容
     * @param {object} data
     * @param {string} data.title
     * @param {string} data.desc
     * @param {string} data.link
     * @param {string} data.imgUrl
     */
    setWxShare(data) {
      WxShare(data);
    },
    /**
     * @description 获取学习内容，暂时
     */
    getLearn(courseId) {
      getCampSeriesLearnDetail_v4_0(courseId).then((res) => {
        this.seriesData.learn_plan.modules = res.learn_plan.modules;
      });
    },
    handlerBuyBtn() {
      this.campDialogMark = FROM_BUY_BTN;
      this.showMoreCamps = true;
      this.pauseTheVideo = false;

      // props 响应性不够，所以采用延时器
      setTimeout(() => {
        this.pauseTheVideo = true;
      }, 10);
    },
    handlerChangeStage() {
      this.showMoreCamps = true;
      this.campDialogMark = FROM_CAMPS_BTN;
      this.pauseTheVideo = false;

      // props 响应性不够，所以采用延时器
      setTimeout(() => {
        this.pauseTheVideo = true;
      }, 10);
    },
    handlerServiceBtn() {
      if (!this.isInitQiYu) {
        Toast('客服系统尚未加载成功，请稍后再试');
        return;
      }

      // eslint-disable-next-line no-undef
      ysf('config', {
        groupid: 264299179, // 指定客服组
        success() {
          ysf('open'); // 指定模板ID
        }
      });

      setTimeout(() => {
        // 未读消息不为0，则更新为0
        if (this.$store.state.qiYu.unreadNum) {
          this.$store.commit('SET_QIYU', { unreadNum: 0 });
        }
      }, 100);
    },
  },
  beforeDestroy() {
    // 页面销毁的时候重置分享内容
    WxShare();
  },
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';

.details-pagearea {
  overflow: hidden;
  position: relative;
  margin: auto;
  width: 100%;
  min-width: 320px;
  max-width: 640px;
  min-height: 100vh;
  background: #fff;
}

.mask-contain {
  position: relative;
  width: 100%;
  // height: 225px;
  // background: #ffc650;
  overflow: hidden;

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    filter: blur(40px);
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .msg-box {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 34px 16px 20px 128px;

    .name {
      width: 100%;
      margin-bottom: 9px;
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      line-height: 24px;
      text-align: left;
      no-wrap();
    }

    .summary {
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      line-height: 14px;
      text-align: left;
      no-wrap();
    }
  }

  .more-msg-box {
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 0 16px 16px 16px;
    background: #FFFFFF;
    border-radius: 12px 12px 0px 0px;

    .nums-box {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-left: 112px;

      .price-box {
        padding: 15px 0 12px 0;
        display: flex;
        align-items: flex-end;

        .price {
          display: inline-flex;
          align-items: flex-end;

          &::before {
            content: '￥';
            font-size: 11px;
            font-weight: 500;
            color: #FC5244;
            line-height: 14px;
          }

          font-size: 20px;
          font-weight: 500;
          color: #FC5244;
          line-height: 20px;
        }

        .original-price {
          margin-left: 8px;
          margin-bottom: 1px;
          font-size: 11px;
          font-weight: 400;
          color: #999;
          // line-height: 18px;
          text-decoration: line-through;
        }
      }

      .sale-count {
        margin-bottom: 12px;
        font-size: 11px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
      }
    }

    .cover-zone {
      position: absolute;
      left: 16px;
      top: -78px;
      width: 100px;
      height: 125px;
      // background: #FFC650;
      border-radius: 6px;
      overflow: hidden;

      .cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .cnum-nd-cdate-box {
      position: relative;
      width: 100%;
      margin-top: 16px;
      background: #FFF6EF;
      border-radius: 4px;
      overflow: hidden;

      .current-camp {
        padding: 10px 12px;

        &>span {
          display: inline-block;
          padding: 6px 8px;
          border-radius: 2px;
          border: 1px solid #FF9645;
          font-size: 12px;
          font-weight: 500;
          color: #FF9645;
          line-height: 12px;

          &:not(:last-child) {
            margin-right: 8px;
          }
        }
      }

      .choose-another-camp {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        display: inline-flex;
        align-items: center;
        margin: auto;
        padding-left: 8px;
        padding-right: 12px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;

        &::after {
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAACVlZWbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZntH403AAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMAAzIlIHI7lAggO06xCJClNGks5IHMCsCtDMYCKEijeRgkQKAAAqyATdyRf7PoAAAAASUVORK5CYII=') center no-repeat;
          background-size: cover;
        }
      }
    }
  }
}

.advertising-wrapper {
  position: relative;
  z-index: 3;
  width: 100%;
  margin-top: -4px;
  padding-bottom: 8px;
  background: #fff;
  overflow: hidden;

  .link {
    display: block;
    width: 100%;

    .img {
      width: 100%;
      object-fit: cover;
    }
  }
}

.about-camp-container {
  width: 100%;
  // margin-top: 8px;
  margin-bottom: 90px;
  background: #fff;

  .tab-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    background: #FFFFFF;
    border-bottom: 0.5px solid #E7E7E7;

    .item {
      flex: 1;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: 400;
      color: #999999;

      &.current {
        position: relative;
        font-size: 18px;
        font-weight: 500;
        color: $color-text;
        transition: all 0.2s;

        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          width: 18px;
          height: 3px;
          margin: auto;
          background: #FF9645;
          border-radius: 2px;
        }
      }
    }
  }

  .wrapper {
    width: 100%;

    .intro-article {
      width: 100%;

      p {
        width: 100%;

        img {
          display: block;
          width: 100%;
          max-width: 100% !important;
        }
      }
    }

    &.intro-wrap {
      padding-top: 15px;
      padding-bottom: 15px;
    }

    &.learn-plan-wrap {
      .try-see-container {
        width: 100%;
        background: #ffffff;
        padding: 15px 16px 0;

        .main {
          position: relative;
          width: 100%;
          padding-top: 22px;
          background: #F6F7FA;
          border-radius: 4px;

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: -4px;
            left: 12px;
            width: 54px;
            height: 24px;
            background: url('../../common/images/catalog_icon_try@2x.png') center no-repeat;
            background-size: cover;
          }

          .item {
            position: relative;
            display: block;
            width: 100%;
            padding: 16px 16px 16px 48px;

            &::before {
              content: '';
              display: block;
              position: absolute;
              top: 24px;
              left: 16px;
              width: 24px;
              height: 24px;
              background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAilBMVEUAAAAAAAAAAAAgICAXFxcaGhoYGBgXFxcXFxcWFhYcHBwbGxsYGBgYGBgaGhoYGBgXFxcaGhoaGhoaGhoZGRkaGhoZGRkYGBgYGBgZGRkZGRkZGRkZGRkYGBgaGhoZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkihYc7AAAALXRSTlMAAwYICxQVFiEiJDk/QERKV1hiY2hten5/hZikqrKzxMrNztfa6+/x8/j5/f6OrXxbAAABNUlEQVRIx+2V21qDMBCEU5CmFa1FgSIHAREUyP/+r+eVLaGkNb3u3u2ww7eZ3UyEuMdNsQmzuu37ts7CzfXqVVAqjqHKYHW5ftcwi2Z3odxNFTAUkS8dR/pRMQAqdU316wroEu+EeEkHVGtDfQPkUgdlDjSLDLeCMT7H4xGqpa5SGPdLf9qPkC7ooyBe7jUGdabVqoHcpEYOzXweAXTSRJAdBDOshIN5QAmUOrJVDJ6Z4A0ofa9CKCbp06ujMwoINSCDaJL+8PWifY8g04Aa/EkK8PE4AXyoNUILckagf3846QStRujBmRPg8wg40P+DUJsJ1i1ZH3om6/dVWWeDe367Njjr1RAlJDbLZ7/e1hfI+oram4C9zVgb2Z9VHqZWebhklfZmbG/3NzwoQgixtXqy7rEUv1i5PlGq261dAAAAAElFTkSuQmCC') center no-repeat;
              background-size: cover;
            }

            .name {
              font-size: 14px;
              font-weight: 400;
              color: #191919;
              line-height: 20px;
            }

            .duration {
              margin-top: 8px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 12px;
            }
          }
        }
      }

      .modules-wrapper {
        .box {
          &.if-preview {
            position: relative;
            margin-top: 17px;

            &::after {
              content: '';
              position: absolute;
              left: 12px;
              top: -4px;
              display: block;
              width: 54px;
              height: 24px;
              background: url('../../common/images/catalog_icon_preview@2x.png') center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
}

.page-bottom-fixed-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: auto;
  max-width: 640px;

  .service {
    position: absolute;
    top: -104px;
    right: 16px;

    .tip-text {
      position: absolute;
      right: 6px;
      top: 6px;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #ff4c52;
      font-size: 12px;
      font-style: normal;
      color: #fff;
      transform scale(.8)
    }

    .service-icon {
      width: 54px;
      height: 54px;
    }
  }

  .operate-bar-box {
    position: relative;
    display: flex;
    -ms-align-items: center;
    align-items: center;
    height: 49px;
    background-color: #fff;

    .s-btn {
      display: block;
      width: 50px;
      height: 40px;
      margin: auto;

      .icon {
        display: block;
        width: 22px;
        height: 22px;
        margin: 0 auto;
      }

      .text {
        display: block;
        margin-top: 2px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(25, 25, 25, 0.78);
        line-height: 14px;
        text-align: center;
        no-wrap();
      }

      &.home-btn {
        .icon {
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAABYlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAqKioAAAAkJCQgICAcHBwaGhoXFxcVFRUUFBQSEhIREREiIiIgICAbGxsaGhoXFxcVFRUUFBQUFBQcHBwYGBgeHh4cHBwbGxsaGhoZGRkYGBgXFxcZGRkZGRkYGBgcHBwbGxsaGhoZGRkYGBgZGRkZGRkYGBgcHBwbGxsaGhoaGhoZGRkYGBgaGhoYGBgbGxsaGhoZGRkZGRkaGhoaGhoZGRkaGhoZGRkZGRkaGhoaGhoZGRkbGxsZGRkZGRkZGRkbGxsaGhoaGhoaGhoaGhoZGRkZGRkZGRkaGhoaGhoaGhoZGRkZGRkZGRkaGhoaGhoaGhoZGRkZGRkZGRkZGRkaGhoaGhoaGhoaGhoZGRkZGRkZGRkZGRkaGhoaGhoZGRkaGhoaGhoaGhoaGhoZGRkZGRkZGRkZGRkZGRkZGRkaGhoZGRkaGhoaGhoaGhosMK7GAAAAdnRSTlMAAQIDBAUGBgcHCAkKCwwNDg8PEBMUFhgZGhsgIiQmKCkrLTIzNTc4Oz5ARkhJSktNT1JUV15gY2Zoa21vdnh8f4GEhoyOkJCRkpOVlpiZmp+goqOkpqeoqq2vsLGys7S1tre4uLm6uru8vb6/wMHCw8PExcbHTw+T4AAAAYBJREFUOMvd1VdXwkAQBeCNgEpXUbCDvQWx94qKikqxYUUUC0hTyP3/PgibRDchPOo+Ze75TrLZzJwQ8k9W/3WsW6sdzwGpIW12roR1PwqTGii3BmGecCsQFqvaxh3kJwghZKaITb26bQ7jdeD7cjSDQ6ua7bzCTVelcD/g3Kls+x4RbRVL1wXue5XsWBZ7ZmlgO8L7CNvOlrChk0eGLRSnWUe2CmHhd7wELHM/w3o/CjzreVMf2DbIo6YTpAbZuxtO49guDTpiuFVsnZ47XLaLpSeB0zblE3We4cFDqyT2LWrfynqAJC0AnXoXGFCS4CrtVVcL1uFTO9bXgg0oaMcNyCtih9vtkAVG5NiY80YFQIh6OSnOMrE1AGQikQwQEIfKhAwLc0EkeD0hej6BIL23mY19iLvKQxWHr5JakGbhEGhX8wjRvbFxTqBTaBboEdiQYmDpa5MsjOUrO94Y2CTHpsog4aUW/Kwdt+BJO3bIsLhkWFwJmoarYmH3r/7yvgDWTHmek2D8eQAAAABJRU5ErkJggg==') center no-repeat;
          background-size: 22px;
        }
      }

      &.favor-btn {
        .icon {
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAABfVBMVEUAAAAAAAAAAABVVVUzMzNJSUlAQEA5OTlVVVVNTU1GRkZAQEBVVVVQUFBNTU1GRkZMTExJSUlSUlJKSkpLS0tLS0tJSUlNTU1LS0tLS0tMTExKSkpNTU1OTk5MTExOTk5MTExLS0tKSkpMTExMTExLS0tNTU1NTU1NTU1LS0tNTU1NTU1LS0tNTU1MTExLS0tLS0tNTU1MTExLS0tNTU1MTExNTU1LS0tNTU1MTExLS0tLS0tMTExLS0tMTExMTExLS0tNTU1MTExMTExMTExMTExLS0tNTU1LS0tNTU1MTExMTExMTExMTExMTExNTU1MTExNTU1MTExMTExLS0tNTU1NTU1NTU1MTExMTExMTExLS0tMTExMTExMTExMTExMTExLS0tMTExMTExNTU1MTExMTExMTExMTExNTU1MTExMTExMTExMTExMTExMTExLS0tMTExMTExMTExMTExMTExMTExMTExLS0tMTExMTExMTExLS0tMTExMTEwN/1QlAAAAfnRSTlMAAQIDBQcICQkKCwwMEBQWGxwcHyIpKissMzY3ODs8PkBBRUZKS0xPU1VaXV9gYWNmZmttbW9wdHd5en2AhYeJjo+QkZOUlZWYmZqdnqGio6Wmp6iprbC0u7y9vr/FxsfKy8zNzs/X2eLi5OXn6e7v8PHy8/X3+Pn6+/z9/v5kmkXaAAABzElEQVQYGd3BZ1tSYQAG4AcPWG5IGW5SnJmWlnsggqkNtyJJy70VOIxz9PntHg/kpdf7Knyt+8b/4s3x8VsUyJ0hM24UZpWhEFdREJeu2u2q7kIhVhgEglxBAZyaagfsquZEfssMwRDiMvJyakkHDI6k5kQ+S5yFaZZLyKNWSzpgepXUavGMl57eE/qR4+dJr+cFBMWujqG5yKFOcrsEOSXbJPXDyNxQh6sYf3l+6TSl9td7FNxTetb3UzTpP93I+sP0wWagv7VGgUCpae0PbB6kuYOsSzYij0ZeIivIiwY8q+GCn5BlXWOsGc9ojnHNihzlGxMteFJLgl8V3CtaoNqOJ7SrXCjCA5YZpjoh1ZnijAWPTTHTDYnuDKcgGGe6CYKmNMchMckIBN85CZnyaxUC9bocMmVMQJBgGWTquQfBHush08dFCBbZB5lpDkMwzGnIhNkGQRvDkDllNUxVY1tbY1UwVfMUEpW8wp2KiTgN8YkK3LliJUSvGQVQOnrOmw2fb+OG56OlAH7QC9EA52EbPCPDdTDUhcmzQRvmOQBRgCPvj8ioFzneKHn0boR+iD7SsOvDA75dGj5AZP0S+91lwSOWrp34Zxv+ZbcQKXW+XP1/JgAAAABJRU5ErkJggg==') center no-repeat;
          background-size: 22px;
        }

        &.is-favor {
          .icon {
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABOUExURUxpcf+WRf+kW/+WRP+WRP+WRP/clf+WRf+WRf+ZR/+XRP+aTP+YRf+WRf+WRf+YRf+WRf+ZR/+YRf+fRf+XRf+WRv+WRv+cQ/+WRP+WRVT95/cAAAAZdFJOUwD6B+DstAH+zS49EVxovYjFS34w1pCqMZ/nXKWOAAAA6UlEQVR42t3S2w6CMAwG4I0VyubGUdS9/4t6wpVoZ5dwpf8d4eNP26D+JUFrX2pnjBHnQtzGW9oya/GO0ZYXU7VcTNVyMVXLxVQtFxdXOySM7puszpOOm+jpXDHK+qUzmlqpXZtu8Za+sQajEIR5xRALAivGEowrrktw91qvlW2bVmwGyQ6NSmk6YYa7Jf117vppKae8PamPXHL2opjUmRkUlwOPD/ux47Fj8cTjSe1e0PDYsFjzWAvHkM8x0utjCEd6GhncpyHd45BphT5/DEhFI9A52GbwahMPueZqQAhvP24TAIdK/XKuKrFFbmF9/o8AAAAASUVORK5CYII=') center no-repeat;
            background-size: 22px;
          }
        }
      }
    }

    .btns {
      flex: 1;
      height: 40px;
      padding-right: 16px;
      overflow: hidden;

      .btn {
        width: 100%;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;

        &.buy-btn {
          background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
        }

        &.paid-btn {
          background: #14B0FF;
        }

        &.sale-out-btn {
          background: #ababab;
        }
      }
    }
  }
}

.van-action-sheet {
  background: transparent;
  // max-width 640px
}

.choose-camp-dialog-main {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 64vh;
  max-width: 640px;
  margin: 0 auto;
  background-color: #fff;
  overflow: hidden;

  .close-dialog {
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    width: 44px;
    height: 44px;
    background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAwBAMAAACh2TSJAAAAG1BMVEUAAAD///+fn5+ZmZmYmJiampqampqZmZmZmZkkhmHnAAAACHRSTlMAAQhnd3ecnSLNvDoAAACaSURBVDjL5ZI9FkBADISzfnrVah1B4QDu4AQ6rc4JyLEtHlnMvKe33czmy8tLRuRXL+kKE66pTOTam/Damkh1viA3aB01GAzyUdVNxkV3/UDMeCLmvJDTeiOnB5DDRMgBQWSHILJDGNkgjIiUqiP8cJPqUmCETBAGGEs4gg+tQsNevm+HbpRfgV6OX5smhKeKJzGj6eWJ/8VbATTyQ1fYqRzvAAAAAElFTkSuQmCC') center no-repeat;
    background-size: 24px;
    z-index: 3;
  }

  .camp-msg-box {
    position: relative;
    // height 124px
    padding: 24px 16px 20px 108px;

    .cover-zone {
      position: absolute;
      top: 24px;
      left: 16px;
      width: 80px;
      height: 100px;
      // background: #FFC650;
      border-radius: 5px;
      overflow: hidden;

      .cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .cont-zone {
      width: 100%;

      .name {
        height: 34px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #191919;
        line-height: 34px;
        text-align: left;
        no-wrap();
      }

      .price-box {
        display: flex;
        align-items: flex-end;
        margin-bottom: 26px;

        .price {
          &::before {
            content: '￥';
            font-size: 11px;
            font-weight: 500;
            color: #FC5244;
            line-height: 11px;
          }

          font-size: 18px;
          font-weight: 500;
          color: #FC5244;
          line-height: 18px;
        }

        .original-price {
          margin-left: 8px;
          font-size: 11px;
          font-weight: 400;
          color: #999999;
          line-height: 15px;
          text-decoration: line-through;
        }
      }

      .selected-camp {
        &::before {
          content: '已选择：';
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }

        font-size: 12px;
        font-weight: 400;
        color: #FF9645;
        line-height: 12px;
      }
    }
  }

  .camps-box {
    flex: 1;
    overflow: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 0 16px 44px;

    .subs {
      padding: 12px 0;
      font-size: 14px;
      font-weight: 400;
      color: #191919;
      line-height: 14px;
    }

    .camp-list {
      .camp-item {
        position: relative;
        margin-bottom: 12px;
        padding: 12px;
        background: #F6F7FA;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: $color-text;

        &>span {
          display: inline-block;
          line-height: 14px;
          padding: 6px 8px;
          border-radius: 2px;
          border: 1px solid #DADADA;

          &:not(:last-child) {
            margin-right: 8px;
          }
        }

        &::after {
          content: '';
          display: block;
          width: 16px;
          height: 16px;
          position: absolute;
          top: 17px;
          right: 12px;
          background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAY1BMVEUAAADMzMzU1NTb29vq6urk5OTe3t7f39/c3Nzd3d3d3d3b29vZ2dnd3d3c3Nza2tra2tra2trb29va2trb29va2tra2tra2tra2trb29va2tra2tra2tra2trb29va2tra2tr4uqhgAAAAIHRSTlMABQYHDBMXGCQmLTg8PFd1iZmbq7/Ax8jd4ur0+Pn9/kcaIAIAAADXSURBVDjLhVPHFoMwDBMBwt4jbPT/X9lD+6AFUuvmZ8WRh4ADXl6ZaVkmU+Ue7gjrmQfmOryk3XLl1hWZVkpnRbdxLd3vfNBzb6IzjpqdfXDG8cgh+S2ZDBzj4/3I1r9q8luOnxpuz9a5q3Za9m8dJQf/oS34A0sACNc9wSOSfQ0B1GxgQcMa8OYtshGibfaQs4MVHXNULOyEghUMUzshpcFEbSdoTlio7ATFRSaIX/wVmdHIbYqDEkctLktet3gw8smJRyufvWycw3qpVkqnD9aTzWu3/wte+xdwPXVqzQAAAABJRU5ErkJggg==') center no-repeat;
          background-size: cover;
        }

        &.current {
          font-weight: 500;
          color: #FF9645;

          &>span {
            border: 1px solid #FF9645;
          }

          &::after {
            content: '';
            display: block;
            width: 16px;
            height: 16px;
            position: absolute;
            top: 17px;
            right: 12px;
            background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAflBMVEUAAAD/kkn/lUD/lUD/lUf/mUT/lUb/l0X/lkT/lkX/lkX/lkX/lkX/lkX/lkX/lkX/l0X/lkX/l0j/mk3/m07/nFD/n1X/pF7/snj/tn7/vIn/vYv/voz/vo3/v4//wJD/xJj/2Ln/5ND/6Nf/7N//7uH/7+P//v3//v7///+GXZW0AAAAEXRSTlMABwwYJC1XiZmbx8ji6vT4+TH0AcAAAADoSURBVDjLhZNXFoMgEEWxF1ScFNO7Ke5/gxkQKyDvB4/3KVMJ6eWGMc0Zy2kcukSVnxTQq0j8GXaiEiYqI2fMvRQUpd7Agww0yoL+ey1Hh/yHk4JBaRtHBEZFIr9Syy6fPebCs020/Ppr3ngkWL/CwL9HXjGXhCZ+Ek8hiRc5xIQucqAkX+SQE8aP1WGj58Baw6N5beWb24SjQVzxbDrHjOMVIsiqlg7Oz+OAqExTOhSOacpCCcdd4ViortTc0SgcS903izvmnDdraHdVK1y0exiY9U47MPaRsw6tfezti2NfPfvymtf/D0yKPDegwe1TAAAAAElFTkSuQmCC') center no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }

  .buy-btn {
    padding: 5px 16px 4px;

    .text {
      display: block;
      width: 100%;
      height: 40px;
      background: linear-gradient(270deg, #FA8C1D 0%, #FCB13F 100%);
      border-radius: 6px;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;

      &.buy {
      }

      &.paid {
        background: #14B0FF;
      }

      &.sale-out {
        background: #ababab;
      }
    }
  }
}

.video-box {
  width: 100%;
  position: relative;
  margin: auto;
  padding: 0 16px;
  background-color: #fff;
  overflow: hidden;
}

.divider {
  width: 100%;
  height: 8px;
  background: #F6F7FA;
}

/deep/ .van-popup--bottom.van-popup--round {
  border-radius: 12px 12px 0 0;
}
</style>
